import { render, staticRenderFns } from "./OtherEventComponent.vue?vue&type=template&id=2ef6c7a3&scoped=true&"
import script from "./OtherEventComponent.vue?vue&type=script&lang=js&"
export * from "./OtherEventComponent.vue?vue&type=script&lang=js&"
import style0 from "./OtherEventComponent.vue?vue&type=style&index=0&id=2ef6c7a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6c7a3",
  null
  
)

export default component.exports